<template>
    <div class="user-profile ccbs" v-if="carregado">
        <div class="row">
            <div class="col-12 tit_page">
                <div class="float-left">
                    <h1>Formalizar CCB</h1>
                </div>
                <div class="back float-right text-right">
                    <a @click="$router.go(-1)" href="javascript:;" title="Voltar">
                        <i class="back">&nbsp;</i> <span>Voltar</span>
                    </a>
                </div>
            </div>
        </div>
        <hr class="divider">
        <div class="row ccbs__title">
            <div class="col-12">
                <h2>{{(ReservaInvestimento.SolicitacaoId.Empresa.NomeFantasia == undefined || ReservaInvestimento.SolicitacaoId.Empresa.NomeFantasia == "")? ReservaInvestimento.SolicitacaoId.Empresa.RazaoSocial : ReservaInvestimento.SolicitacaoId.Empresa.NomeFantasia}}</h2>
                <span>CNPJ: {{formattedCnpj()}}</span>
                <small>{{formatarTipoEmprestimo(ReservaInvestimento.SolicitacaoId.TipoEmprestimo)}}</small>
            </div>
        </div>
        <hr class="divider">
        <div class="row ccbs__info">
            <div class="col-12 col-md-7 col-lg-8">
                <div class="row">
                    <div class="col-12 col-md-6 col-lg-4 mt-2 mb-3">
                        <div class="box p-3">
                            <label>Valor investido</label>
                            <span>R$ {{formatCurrency(ReservaInvestimento.Valor)}}</span>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2 mb-3">
                        <div class="box p-3">
                            <label>Valor de pagamento mensal</label>
                            <span>R$ {{formatCurrency(valorMensal)}}</span>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2 mb-3">
                        <div class="box p-3">
                            <label>Data do investimento</label>
                            <span>{{toLocaleDateString(ReservaInvestimento.Created)}}</span>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2 mb-3">
                        <div class="box p-3"> 
                            <label>CDI</label>
                            <span>{{formatCurrency(ReservaInvestimento.SolicitacaoId.Cdi)}}%</span>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2 mb-3">
                        <div class="box p-3">
                            <label>Taxa interna de retorno</label>
                            <span>35.5% a.a. </span>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2 mb-3">
                        <div class="box p-3">
                            <label>Taxa total efetiva</label>
                            <span>{{formatCurrency(ReservaInvestimento.SolicitacaoId.CustoEfetivoTotalaa)}}% a.a.</span>
                        </div>
                    </div>

                    <div class="col-12 mt-2 mb-3">
                        <h3>Dados do empréstimo</h3>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2 mb-3">
                        <div class="box p-3">
                            <label>Valor total solicitado</label>
                            <span>R$ {{formatCurrency(ReservaInvestimento.SolicitacaoId.Valor)}}</span>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2 mb-3">
                        <div class="box p-3">
                            <label>Duração</label>
                            <span>{{ReservaInvestimento.SolicitacaoId.Prazo}} meses</span>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2 mb-3">
                        <div class="box p-3">
                            <label>Data</label>
                            <span>{{toLocaleDateString(ReservaInvestimento.SolicitacaoId.InicioCaptacao)}}</span>
                        </div>
                    </div>

                    <div class="col-12 mt-2 mb-3">
                        <h3>Dados da empresa</h3>
                    </div>
                    <div class="col-12 col-md-6 col-lg-6 mt-2 mb-3">
                        <label>Empresa (Razão social)</label>
                        <span>{{ReservaInvestimento.SolicitacaoId.Empresa.RazaoSocial}}</span>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3 mt-2 mb-3">
                        <label>CPF/CNPJ</label>
                        <span>{{formattedCnpj()}}</span>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3 mt-2 mb-3">
                        <label>Nome do responsável</label>
                        <span>{{ReservaInvestimento.SolicitacaoId.Solicitante.NomeCompleto}}</span>
                    </div>
                    <div class="col-12 col-md-6 col-lg-6 mt-2 mb-3">
                        <label>Nome fantasia</label>
                        <span>{{ReservaInvestimento.SolicitacaoId.Empresa.NomeFantasia}}</span>
                    </div>
                    <div class="col-12 col-md-6 col-lg-6 mt-2 mb-3">
                        <label>Telefone comercial</label>
                        <span>{{ReservaInvestimento.SolicitacaoId.TelefoneComercial}}</span>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3 mt-2 mb-3">
                        <label>Data de fundação</label>
                        <span>{{toLocaleDateString(ReservaInvestimento.SolicitacaoId.Empresa.DataFundacao)}}</span>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3 mt-2 mb-3">
                        <label>Número de funcionários</label>
                        <span>{{ReservaInvestimento.SolicitacaoId.Empresa.QuantidadeEmpregados}} empregados</span>
                    </div>
                    <div class="col-12 col-md-6 col-lg-6 mt-2 mb-3">
                        <label>Nome do grupo ecônomico</label>
                        <span>{{ReservaInvestimento.SolicitacaoId.Empresa.NomeGrupoEconomico}}</span>
                    </div>
                    <div class="col-12 mt-2">
                        <label>Endereço</label>
                        
                        <span>{{ReservaInvestimento.SolicitacaoId.Empresa.Endereco.Logradouro}},
                            {{ReservaInvestimento.SolicitacaoId.Empresa.Endereco.Numero}}  
                             {{ReservaInvestimento.SolicitacaoId.Empresa.Endereco.Complemento ? " - " + ReservaInvestimento.SolicitacaoId.Empresa.Endereco.Complemento : "" }}
                            {{ReservaInvestimento.SolicitacaoId.Empresa.Endereco.Bairro ? ", " + ReservaInvestimento.SolicitacaoId.Empresa.Endereco.Bairro : ""}}  
                            {{ReservaInvestimento.SolicitacaoId.Empresa.Endereco.Cep ? " - " + ReservaInvestimento.SolicitacaoId.Empresa.Endereco.Cep : "" }}, 
                            {{ReservaInvestimento.SolicitacaoId.Empresa.Endereco.Cidade}}/{{ReservaInvestimento.SolicitacaoId.Empresa.Endereco.Uf}} 
                        </span>
                        
                    </div>                    
                </div>
            </div>
            <aside class="col-12 col-md-5 col-lg-4 mt-2 mb-3">
                <div class="box p-3 p-md-4">
                    <div class="box-form" v-if="this.passo != 3">
                        <img src="/static/assets/images/ico-atencao-ccb.svg" class="ico-atencao" alt="icone atenção">
                        <h4>{{Nome()}}, falta assinar sua CCB</h4>
                        <div class="box box-ccb p-2 d-flex justify-content-between align-items-center">
                            <span class="m-1 d-flex align-items-center">
                                <img src="/static/assets/images/ico-pdf.png" alt="icone ccb">
                                <small>{{this.ReservaInvestimento.CodigoBMP}}</small>
                            </span>
                            <span>
                                <a :href='CCB_URL+"/imprimirccb.aspx?code="+this.ReservaInvestimento.CodigoBMP+"&copias=1"' class="btn btn-sm btn-link" target="_blank" title="Visualizar CCB">Visualizar</a>
                            </span>
                        </div>
                        <form v-if="!this.ccb">
                            <span class="text">Aguardando as assinaturas dos sócios e tomadores.</span>
                            <button class="btn btn-lg btn-primary btn-block" disabled="false">Em aguardo</button>
                            <!-- <button class="btn btn-lg btn-link btn-block">Cancelar</button> -->
                        </form>
                        <form v-if="this.passo == 1 && this.ccb">
                            <button class="btn btn-lg btn-primary btn-block" @click.prevent="passo = 2;">Assinar</button>
                            <!-- <button class="btn btn-lg btn-link btn-block">Cancelar</button> -->
                        </form>
                        <form v-if="this.passo == 2 && this.existesenha && this.ccb">
                            <span class="text">Por favor insira sua senha no campo abaixo para finalizar a assinatura de sua CCB.</span>
                            <input class="form-control form-control-lg" v-model="password" type="password" placeholder="Sua senha aqui">
                            <button class="btn btn-lg btn-primary btn-block"  @click.prevent="ValidarSenha()">Assinar</button>
                            <button class="btn btn-lg btn-link btn-block" @click.prevent="passo = passo-1">Cancelar</button>
                        </form>

                        <form v-if="this.passo == 2 && !this.existesenha && this.ccb">
                            <span class="text">Por favor entre no link abaixo para cadastrar uma senha.</span>
                            <button class="btn btn-lg btn-primary btn-block"  @click.prevent="CadastrarSenha()">Cadastrar senha</button>
                        </form>
                    </div>

                    <!-- ínicio mensagem confirmação -->
                    <div class="box-confirm" v-if="this.passo == 3">
                        <img src="/static/assets/images/icon-success.svg" alt="icone ok">
                        <h5>Obrigado, {{Nome()}}.</h5>
                        <p>Sua CCB foi assinada com sucesso!</p>
                    </div>
                    <!-- final mensagem confirmação -->
                </div>
            </aside>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
    import ApiClient from '../utils/api-client'
    import HubClient from '../utils/hub-consulta-client'
    import Masker from '@/utils/masker'
	import * as mutationTypes from '@/store/mutation-types.js'
    export default {

        data() {
                return {
                    CCB_URL:process.env.CCB_URL,
                    ReservaInvestimento:{},
                    reservas: {},
                    socios: {},
                    passo : 1,
                    password :'',
                    id : '',
                    smsToken : '',
                    tentativas: 3,
                    carregado: false,
                    valorMensal : 0,
                    IP : '',
                    existesenha : true,
                    ccb:false
                }
        },
        computed: {

                        User: function () {
                            return this.$store.state.currentUser;
                        }
                   },

         methods: {

                formattedCnpj() {
                    return Masker.maskCnpj(this.ReservaInvestimento.SolicitacaoId.Documento)
                },
                formatarTipoEmprestimo(tipoEmprestimo) {
                    if (tipoEmprestimo.toLowerCase() == "emprestimo-de-impacto2") {
                    return "Impacto";
                    }

                    var splitedTipoEmprestimo = tipoEmprestimo.split('-');

                    if (splitedTipoEmprestimo.length > 1) {
                    return splitedTipoEmprestimo[1][0].toUpperCase() + splitedTipoEmprestimo[1].substr(1);
                    }

                    return tipoEmprestimo[0].toUpperCase() + tipoEmprestimo.substr(1);
                },
                ajustIdOportunidade(id, qtd) {
                    var s = String(id);
                    while (s.length < (qtd || 2)) {
                    s = "0" + s;
                    }
                    return s;
                },
                formatCurrency(value) {
                    if (value == null || value == undefined)
                    return parseFloat(0).toLocaleString('pt-BR', {
                        minimumFractionDigits: "2",
                        maximumFractionDigits: 2
                    })

                    return value.toLocaleString('pt-BR', {
                    minimumFractionDigits: "2",
                    maximumFractionDigits: 2
                    })
                },
                toLocaleDateString(value){
                    if(value != undefined){

                        if(typeof value == "string"){
                            value = new Date(value)
                        }

                        return value.toLocaleDateString('pt-BR');
                    }

                    return "";
                },
                Nome() {
                        var nome = "",
                        letra = "";
                        if (this.User.name == undefined || this.User.name == null || this.User.name == "") {
                        nome = this.User.username;
                        } else {
                        nome = this.User.name;
                        }

                        this.existesenha = this.User.HasPass;
                          nome = nome.trim();
                        var primeiroNome = nome.split(" ")[0];
                        return primeiroNome[0].toUpperCase() + primeiroNome.toLowerCase().substring(1);
                    },

                ValidarSenha() {
                    
                    this.id = this.User._id; 
                    ApiClient.VerificaSenha(this)
                    .then(() => {

                        console.log(`out/atualizaCCbsInvestidoresAssinatura/${this.$route.params.id}/${this.IP}`)
                        
                          ApiClient.get_GO(`out/atualizaCCbsInvestidoresAssinatura/${this.$route.params.id}/${this.IP}`)
                            .then(token => {
                              this.passo = 3;
                              this.password = '';

                            }).catch((ex) => {

 

                            });  
                    })
                    .catch(() => {
                        //Verificação do password
                        this.password = ''
                        this.tentativas --
                        if(this.tentativas == 0) {
                            this.$router.push("/login")
                            this.$Notify.error("Erro: Você excedeu o número de tentativas limite!")
                        }
                        if(this.tentativas != 0)
                            this.$Notify.error("Erro: Senha Inválida! Tentativas restantes: " + this.tentativas)
                    });
                },
                CadastrarSenha(){
                    this.$router.push("/investimentos/perfil/dados-pessoais")
                },
                PMT(rate, periods, present, future, type) {
                // Credits: algorithm inspired by Apache OpenOffice

                // Initialize type
                type = (typeof type === 'undefined') ? 0 : type;

                // Initialize future
                future = 0;

                // Evaluate rate (TODO: replace with secure expression evaluator)
                rate = eval(rate);

                // Return payment
                var result;
                if (rate === 0) {
                result = (present + future) / periods;
                } else {
                var term = Math.pow(1 + rate, periods);
                if (type === 1) {
                    result = (future * rate / (term - 1) + present * rate / (1 - 1 / term)) / (1 + rate);
                } else {
                    result = future * rate / (term - 1) + present * rate / (1 - 1 / term);
                }
                }

                // result = Math.round(result * 100) / 100;

                return -result;
            },
            getClientAddress() {
                     HubClient.getIP().then(ip => {
                        this.IP = ip;
                    })
                           
			   },
			
			//tagueamento GA
			taggingGA() {
				this.$ga.page({
					page: '/cadastrar-senha',
					title: 'CadastrarSenha',
				})
    		},
         },
        async created() {

        this.reservaInvId = this.$route.params.id

        if(window.location.href.indexOf("dashboard-app") != -1)

            this.getClientAddress();
            this.$store.commit(mutationTypes.START_LOADING)

            ApiClient.getInfosMyInvestmentsSolicitacoes(this.$route.params.id)
                .then(loanRequest => {
                    this.ccb = loanRequest.data.ccb
                    this.ReservaInvestimento = loanRequest.data.dados.filter((item)=>{return item._id == this.reservaInvId;})[0];
                    this.carregado = true;

                        if(this.ReservaInvestimento.SolicitacaoId.RetornoBrutoMensal  == undefined){
                            this.ReservaInvestimento.SolicitacaoId.RetornoBrutoMensal = 0;
                        }

                    
                    this.valorMensal = -this.PMT(this.ReservaInvestimento.SolicitacaoId.RetornoBrutoMensal / 100, this.ReservaInvestimento.SolicitacaoId.Prazo, this.ReservaInvestimento.Valor);

                    if(this.ReservaInvestimento.AssinouCCB == true)
                    {
                        this.passo = 3;
                    }
                    this.$store.commit(mutationTypes.STOP_LOADING)

                }).catch(() =>{
                    this.$store.commit(mutationTypes.STOP_LOADING) 
				})
				
			//tagueamento GA
            await this.taggingGA()
        }
        
    }
</script>

<style lang="scss" scoped>
    .user-profile {
        .tit_page {
            padding-bottom:0px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/CCBInvestor.vue